module.exports = __webpack_public_path__ + "media/images/features/modification/icon-balloon-84a15e89cca11c9c4ad52a064f1744c0.svg";